import { Attachment } from '../../../shared-components/models/attachment.model';

export class CheckInOutButtonSettings {
    AllowParentEnterCheckInOut: boolean;
    AllowParentEnterCheckInOutMobile: boolean;
    AllowParentEnterAbsentNotice: boolean;
    AllowStudentEnterCheckInOut: boolean;
    AllowStudentEnterCheckInOutMobile: boolean;
    AllowStudentEnterAbsentNotice: boolean;
   }

   export class CheckInOutSubmissionRequest {
    Id = 0;
    StudentId: number;
    Type = 'I';
    Time = '';
    Reason = '';
    SubmissionAttachment: Attachment[] = [];
    ProcessedTime = '';
    Date: Date;
    Status = '';
    Attachment: boolean;
    SubmittedBy = '';
   }
